export default __webpack_public_path__ + "static/media/client-11.89d9d896.webp";